import { useHistory } from 'react-router-dom';

import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthService, ResendEmailRequestForm } from '@/services/Auth';

export const useResendEmailRequest = (): ((email: string) => Promise<void>) => {
  const authService = new AuthService(getClient());
  const history = useHistory();

  const resendEmailRequest = async (email: string) => {
    const body: ResendEmailRequestForm = { email };
    return await authService
      .resendEmailRequest(body)
      .then(() => history.push('/resend-email/requested'))
      .catch((error: Error) => errorHandler({ error }));
  };

  return resendEmailRequest;
};
